import React, { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { ChevronDownIcon } from "lucide-react";
import { CtaButton } from "../CtaButton";
import { SectionHeading } from "../SectionHeading";
import { faqs } from "../../data/landing";
export function Faq() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="bg-cream px-4 py-16 sm:py-24" data-id="element-136" data-mp="122vbicn8knnw">
      <div className="mx-auto max-w-3xl" data-id="element-137" data-mp="1prxupoxiqoki">
        <SectionHeading title="Frequently asked questions" data-id="element-138" data-mp="1pszechslojdu" />
        <ul className="mt-10 space-y-3" data-id="element-139" data-mp="1uq92zv860r0m">
          {faqs.map((f, i) => {
          const isOpen = open === i;
          return <li key={f.q} className="overflow-hidden rounded-2xl bg-white shadow-[0_4px_16px_-8px_rgba(11,27,58,0.15)]" data-id="element-140" data-mp="1g0bm80ckf3lg" data-mpi={i}>
                <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-4 px-5 py-5 text-left text-[17px] font-bold text-navy focus:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-gold" data-id="element-141" data-mp="28r22kudbqcal">
                  {f.q}
                  <ChevronDownIcon className={`h-5 w-5 shrink-0 text-gold-dark transition-transform duration-200 ease-out ${isOpen ? "rotate-180" : ""}`} aria-hidden="true" data-id="element-142" data-mp="2ygk18o8uncpg" />
                </button>
                <AnimatePresence initial={false} data-id="element-143" data-mp="37ita79ogyy0q">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: "auto",
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.22,
                ease: [0.23, 1, 0.32, 1]
              }} data-id="element-144" data-mp="32h3zjv55smd6">
                      <p className="px-5 pb-5 text-[16px] leading-relaxed text-ink/75" data-id="element-145" data-mp="1n2zea3qdisjn">{f.a}</p>
                    </motion.div>}
                </AnimatePresence>
              </li>;
        })}
        </ul>
        <div className="mt-10" data-id="element-146" data-mp="2br9cf9x2hz00">
          <CtaButton label="I'm ready — give me the workbook" data-id="element-147" data-mp="2bsaqln9dr1ly" />
        </div>
      </div>
    </section>;
}